/* istanbul ignore file */
// Add services to this type
export enum Services {
    ATVWebPresentationService = 'ATVWebPresentationService',
    ATVDiscoverService = 'ATVDiscoverService',
    PVStarlightPresentationServiceLambda = 'PVStarlightPresentationServiceLambda',
};

export interface WPSSegments {
    endpoints: { [x: string]: string };
    operations: { [x: string]: string }
};

export interface Endpoints {
    serviceEndpoints: { [key: string]: string};
    wpsSegments: WPSSegments;
}

// TODO: Extract inspector types into utils package
export interface Debug {
    operationName: string,
    serviceCalls: ServiceCalls
    logs: string[],
    startMillis: number,
    durationMillis: number,
    hostName: string,
    cacheLog: {
        hint: string;
        key: string;
        status: "Hit" | "Miss" | "None";
        value: string;
    }[]
};

export interface ServiceCalls {
    calls: any,
    meta: any,
};
